export const templateSetKeys = {
  all: ['templateSets'],

  byId: (id?: number) => [...templateSetKeys.list(), { id: id ?? null }],

  list: () => [...templateSetKeys.all, 'list'],

  resolved: (scope: object | null) => [...templateSetKeys.all, 'resolved', scope],
};
